import React, { createContext, useContext, useState, useEffect } from 'react';
import { useOverviewContext } from './OverviewContext'; 
import type { Student } from './OverviewContext';

interface SelectedStudentContextType {
  selectedStudent: Student | null;
  setSelectedStudent: (student: Student) => void;
}

const SelectedStudentContext = createContext<SelectedStudentContextType | undefined>(undefined);

export const SelectedStudentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { students, loading } = useOverviewContext();
  const [selectedStudent, setSelectedStudent] = useState<Student | null>(null);

  
    // Automatically selects the first student if none is currently selected
    useEffect(() => {
      if (!loading && students.length > 0 && !selectedStudent) {
          const stored = localStorage.getItem('selectedStudentId');
          const found = students.find(s => String(s.accountId) === stored);
          setSelectedStudent(found ?? students[0]);
      }
    }, [students, loading, selectedStudent]);

    useEffect(() => {
      if (selectedStudent) {
        localStorage.setItem('selectedStudentId', String(selectedStudent.accountId));
      }
    }, [selectedStudent]);

  return (
    <SelectedStudentContext.Provider value={{ selectedStudent, setSelectedStudent }}>
      {children}
    </SelectedStudentContext.Provider>
  );
};

export const useSelectedStudent = () => {
  const context = useContext(SelectedStudentContext);
  if (!context) {
    throw new Error('useSelectedStudent must be used within a SelectedStudentProvider');
  }
  return context;
};